import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';

export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.shape};
  border-radius: ${RFValue(16)}px;
  border: 1px solid ${({theme}) => theme.colors.border2};
  padding: ${RFValue(12)}px;
  shadow-color: #000;
  shadow-opacity: 0.04;
  shadow-radius: 6px;
  shadow-offset: 0px 4px;
  elevation: 1;
`;

export const StoresColumn = styled.View`
  flex-direction: column;
  gap:${RFValue(12)}px;
`;

export const CategoryHeader = styled.View`
  flex-direction: row;
  align-items: center;

  margin-bottom: ${RFValue(12)}px;
`;

export const StoresList = styled.View`

`;
